import api from './index';
//
let exports = {};

// 获取配件定义列表
exports.getMerchtAccDefListByMerchantId = function (data, callback) {
    api.post('/accStock/mercht/def/list/get/for/select')
    .data(data)
    .done(callback)
    .go();
};

exports.getMerchtAccStockList = function (data, callback) {
    api.post('/accStock/mercht/stock/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取配件定义详情
exports.getAccDefInfo = function (params, callback) {
    api.get('/accStock/def/info/get')
    .params(params)
    .done(callback)
    .go();
};
// 获取关联配件的设备信息
exports.getSpecificAccDevcList = function (postData, callback) {
    api.post('/accStock/specific/acc/devc/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 获取关联配件的机构信息
exports.getSpecificAccList = function (postData, callback) {
    api.post('/accStock/specific/acc/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 个体配件绑定设备
exports.doBoundSpecificAcc = function (postData, callback) {
    api.post('/accStock/specific/acc/bound/do')
    .data(postData)
    .done(callback)
    .go();
};

// 多个个体配件绑定一个设备
exports.doBoundSpecificAccByboundDevcId = function (postData, callback) {
    api.post('/accStock/specific/acc/bound/do/by/boundDevcId')
    .data(postData)
    .done(callback)
    .go();
};

// 个体配件解绑设备
exports.doUnBoundSpecificAcc = function (postData, callback) {
    api.post('/accStock/specific/acc/unBound/do')
    .data(postData)
    .done(callback)
    .go();
};
// 个体配件解绑设备
exports.getSpecificAccRecList = function (postData, callback) {
    api.post('/accStock/specific/acc/rec/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// ====================== 个体化配件返修单 =======================

// 获取个体化配件返修单列表
exports.getSpecificAccRepairVoucherList = function (postData, callback) {
    api.post('/accStock/specific/acc/repair/voucher/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 获取个体化配件返修单详情
exports.getSpecificAccRepairVoucherInfo = function (params, callback) {
    api.get('/accStock/specific/acc/repair/voucher/get')
    .params(params)
    .done(callback)
    .go();
};

// 保存个体化配件返修单
exports.saveSpecificAccRepairVoucher = function (postData, callback) {
    api.post('/accStock/specific/acc/repair/voucher/save/do')
    .data(postData)
    .done(callback)
    .go();
};

// 个体化配件返修单申请操作
exports.applySpecificAccRepairVoucher = function (postData, callback) {
    api.post('/accStock/specific/acc/repair/voucher/apply/do')
    .data(postData)
    .done(callback)
    .go();
};

// 个体化配件返修单审核操作
exports.auditSpecificAccRepairVoucher = function (postData, callback) {
    api.post('/accStock/specific/acc/repair/voucher/audit/do')
    .data(postData)
    .done(callback)
    .go();
};

// 个体化配件返修单发货操作
exports.updateSpecificAccRepairVoucherSentInfo = function (postData, callback) {
    api.post('/accStock/specific/acc/repair/voucher/sentInfo/update/do')
    .data(postData)
    .done(callback)
    .go();
};

// 删除个体化配件返修单
exports.deleteSpecificAccRepairVoucher = function (postData, callback) {
    api.post('/accStock/specific/acc/repair/voucher/delete/do')
    .data(postData)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/accStock.js
// module id = 118
// module chunks = 0